import { useSelector } from 'react-redux';

import _ from 'lodash';
import { format } from 'generic/utils/dateUtils';
import { t } from 'i18next';
import {
  generateLinkToResource,
  getDocumentBaseId,
  getValueByBaseFieldsConfig,
  getValueOrFirstValueFromArray,
} from 'generic/utils/qesUtils';

export default (document) => {
  const { qesdocument } = document;

  const docBaseId = getDocumentBaseId(document);
  const resultsCompleteVisibleInResults = useSelector((state) => state.ux.resultsCompleteVisibleInResults);
  const documentBase = useSelector((state) => {
    const { bases } = state.config;
    return _.find(bases, { base: docBaseId });
  });

  // noms des champs issues de la configuration de la base, permet d'être un peu dynamique
  // et avec de la chance, ne rien avoir à surcharger
  const id = getValueByBaseFieldsConfig(documentBase, qesdocument, 'champId');
  const statusXml = getValueByBaseFieldsConfig(documentBase, qesdocument, 'champEtat');
  const titleXml = getValueByBaseFieldsConfig(documentBase, qesdocument, 'champTitre');
  const pdf = getValueByBaseFieldsConfig(documentBase, qesdocument, 'champPdf');
  const datePubXml = getValueByBaseFieldsConfig(documentBase, qesdocument, 'champDate');

  // noms des champs en durs, difficile de les rendre dynamique en l'état de l'API
  // on prend le premier élément du tableau de valeur s'il y en a plusieur.
  const text = getValueOrFirstValueFromArray(qesdocument?.Text);
  const fileHtml = getValueOrFirstValueFromArray(qesdocument?.File_html);

  const emailAccount = getValueOrFirstValueFromArray(qesdocument?.Account);
  const folder = getValueOrFirstValueFromArray(qesdocument?.Path);
  const language = getValueOrFirstValueFromArray(qesdocument?.Lang);
  const level = getValueOrFirstValueFromArray(qesdocument?.Level);
  const messageId = getValueOrFirstValueFromArray(qesdocument?.Message_id);
  const mime = getValueOrFirstValueFromArray(qesdocument?.Mime);
  const receptionDate = getValueOrFirstValueFromArray(qesdocument?.Date_reception);
  const scope = getValueOrFirstValueFromArray(qesdocument?.Scope);
  const sendDate = getValueOrFirstValueFromArray(qesdocument?.Date_send);
  const typeDocument = getValueOrFirstValueFromArray(qesdocument?.Type);
  const userModif = getValueOrFirstValueFromArray(qesdocument?.USER_MODIF);

  const attachment = qesdocument?.File;
  const sendCc = qesdocument.Cc;
  const sendCcEmail = qesdocument.Cc_email;
  const sendFrom = qesdocument.From;
  const sendFromEmail = qesdocument.From_email;
  const sendTo = qesdocument.To;
  const sendToEmail = qesdocument.To_email;
  const sentences = qesdocument?.Phrase;

  const title = titleXml || `[${t('document.title_undefined')}]`;
  const status = +statusXml;
  const date = format(datePubXml);
  const snippet = _.truncate(text, {
    length: resultsCompleteVisibleInResults ? 150 : 500,
    separator: /,? +/,
  });

  let fileHtmlUrl;
  if (fileHtml) {
    fileHtmlUrl = generateLinkToResource(docBaseId, `html/${fileHtml}`);
  }

  let attachementObject;
  if (attachment) {
    attachementObject = _.map(attachment, (item) => (
      {
        libelle: item.split('/').pop(),
        url: generateLinkToResource(docBaseId, item),
      }
    ));
  }

  return {
    attachementObject,
    date,
    emailAccount,
    fileHtmlUrl,
    folder,
    id,
    language,
    level,
    messageId,
    mime,
    pdf,
    receptionDate,
    scope,
    sendCc,
    sendCcEmail,
    sendDate,
    sendFrom,
    sendFromEmail,
    sendTo,
    sendToEmail,
    sentences,
    snippet,
    status,
    text,
    title,
    typeDocument,
    userModif,
  };
};
